import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getEnrollmentAnswers as getEnrollmentAnswersApi,
  updateEnrollment as updateEnrollmentApi
} from '@/apis/validationAPI'

export const getEnrollmentAnswers = createAsyncThunk(
  'modalValidation/getEnrollmentAnswers',
  async ({ id, surveyId }) => {
    try {
      const response = await getEnrollmentAnswersApi(id, surveyId)
      return response
    } catch {
      throw new Error()
    }
  }
)

export const updateEnrollment = createAsyncThunk(
  'modalValidation/updateEnrollment',
  async ({ id, payload }) => {
    try {
      await updateEnrollmentApi(id, payload)
    } catch {
      throw new Error()
    }
  }
)
